export default "__VITE_ASSET__DhKffkiB__"